module.exports = __webpack_public_path__ + "images/sprites/ui/icon_info_14b624eadb400ced11ed3281d0e2d188.png";